/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var enhancedTableProps = {
  beforeDragSort: {
    type: Function
  },
  expandedTreeNodes: {
    type: Array,
    "default": void 0
  },
  defaultExpandedTreeNodes: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  tree: {
    type: Object
  },
  treeExpandAndFoldIcon: {
    type: Function
  },
  onAbnormalDragSort: Function,
  onExpandedTreeNodesChange: Function,
  onTreeExpandChange: Function
};

export { enhancedTableProps as default };
//# sourceMappingURL=enhanced-table-props.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/table/enhanced-table-props.js
// module id = null
// module chunks = 